import { signOut } from "../lib/api.js";

export function InvitationPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-paper text-ink">
      <div className="w-full max-w-md rounded-lg border border-black/10 bg-white p-8 text-center">
        <h1 className="mb-2 text-xl font-semibold">
          An invitation is required
        </h1>
        <p className="mb-6 text-sm text-ink/60">
          This account does not belong to an organization in Jaypie Studio. Ask
          an owner to send an invitation, then sign in again.
        </p>
        <button
          type="button"
          onClick={signOut}
          className="rounded border border-black/15 px-4 py-2 hover:bg-black/5"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
